import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { useIsOrgAdmin } from "@/stores";
import { AIGovernanceSection } from "@/features/settings/ai-governance/components/ai-governance-section";

const aiGovernanceSearchSchema = z.object({
  folderId: z.string().uuid().optional().catch(undefined),
  folderName: z.string().optional().catch(undefined),
});

function AIDataGovernanceSettings() {
  const canEdit = useIsOrgAdmin();
  const search = Route.useSearch();
  return <AIGovernanceSection canEdit={canEdit} initialFolder={search.folderId ? search : undefined} />;
}

export const Route = createFileRoute("/_admin/settings/ai-data-governance")({
  validateSearch: aiGovernanceSearchSchema.parse,
  component: AIDataGovernanceSettings,
});
